import React, { Component } from 'react'
import { Link } from 'react-router'
import { observer } from 'mobx-react'

@observer(['globals'])
export default class Menu extends Component {
  render() {
    return (
      <div className="sub-menu">
        <div className={ this.props.globals.currentSubPage == 'organizations' ? 'sub-menu-item sub-menu-item-active' : 'sub-menu-item' }>
          <Link to="/admin">Organizations</Link>
        </div>
        <div className={ this.props.globals.currentSubPage == 'users' ? 'sub-menu-item sub-menu-item-active' : 'sub-menu-item' }>
          <Link to="/admin/users">Users</Link>
        </div>
        <div className={ this.props.globals.currentSubPage == 'permissions' ? 'sub-menu-item sub-menu-item-active' : 'sub-menu-item' }>
          <Link to="/admin/permissions">Permissions</Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/menu.js